import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonRegEx } from '@nrwl/common-lib';

@Component({
  selector: 'nrwl-voip-test-proxy-popup',
  templateUrl: './voip-test-proxy-popup.component.html',
  styleUrls: ['./voip-test-proxy-popup.component.scss']
})
export class VoipTestProxyPopupComponent implements OnInit {
  @ViewChild('proxySetup', { static: true }) form: NgForm;

  validAddressRegex: RegExp = CommonRegEx.DNS_NAME;
  sipProxyOption = 'none';
  authName = '';
  authPassword = '';
  aliasName = '';
  address = '';
  port = 5060;
  disableNoneOption = false;
  webProxyOption = 'none';
  formConfig = {
    user: '',
    sign_in: '',
    password: '',
    address: '',
    udpPort: null,
    type: ''
  };
  destinationConfig = {};
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, // eslint-disable-line
    public dialogRef: MatDialogRef<VoipTestProxyPopupComponent>
  ) {}
  ngOnInit(): void {
    if (this.data.data) {
      this.webProxyOption = this.data.data.type === 'custom' ? this.data.data.type : 'none';
      this.resetCustomForm();
    }
    if (this.data?.disableNone) {
      this.disableNoneOption = true;
      this.webProxyOption = 'custom';
    }
  }

  selectProxy(proxyType: string): void {
    if (this.disableNoneOption) return;
    this.webProxyOption = proxyType;
  }
  sendData(): void {
    this.formConfig.user = this.aliasName;
    this.formConfig.sign_in = this.authName;
    this.formConfig.password = this.authPassword;
    this.formConfig.address = this.address;
    this.formConfig.udpPort = this.port;
    this.formConfig.type = this.webProxyOption;

    this.dialogRef.close(this.formConfig);
  }
  resetCustomForm(): void {
    this.webProxyOption = this.data.data.type === 'custom' ? this.data.data.type : 'none';
    if (this.data.data.type === 'custom') {
      this.aliasName = this.data.data.user;
      this.authName = this.data.data.sign_in;
      this.authPassword = this.data.data.password;
      this.address = this.data.data.address;
      this.port = this.data.data.udpPort;
    }
  }

  isValidForm(): boolean {
    if (this.webProxyOption === 'none') {
      return false;
    }
    if (
      this.aliasName &&
      this.address &&
      this.authName &&
      this.authPassword &&
      this.port &&
      this.validAddressRegex.test(this.address) &&
      this.port > 0 &&
      this.port <= 65535 &&
      !this.isOriDestSameUser &&
      !this.isOriDestSameSignin
    ) {
      return false;
    }
    return true;
  }

  get isOriDestSameUser(): boolean {
    if (this.data?.existPopupData) {
      return this.aliasName === this.data.existPopupData?.user;
    }
    return false;
  }

  get isOriDestSameSignin(): boolean {
    if (this.data?.existPopupData) {
      return this.authName === this.data.existPopupData?.sign_in;
    }
    return false;
  }
}
